
import Typography from '@mui/material/Typography';


export const TextDrugAcenocoumarol = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Acenocoumarol is an anticoagulant drug used in the prevention of thromboembolic diseases in infarction and transient ischemic attacks, 
as well as management of deep vein thrombosis and myocardial infarction.

<br /><br />

Acenocoumarol is a coumarin derivative used as an anticoagulant. Coumarin derivatives inhibit the reduction of vitamin K by vitamin K reductase. 
This prevents carboxylation of vitamin K-dependent clotting factors, II, VII, IX and X, and interferes with coagulation. 
Hematocrit, hemoglobin, international normalized ratio and liver panel should be monitored. Patients on acenocoumarol are prohibited from giving blood.
<br /><br />

Sources: <br /><br />
https://go.drugbank.com/drugs/DB01418<br />
https://www.pharmgkb.org/chemical/PA452632/prescribingInfo 

</Typography>

</div>

)
}